<template>
  <div id="login">
    <!-- TITLE//S-->
    <div class="page-header">
      <h3>{{ $t("otp.title") }}</h3>
    </div>
    <!-- TITLE//E-->
    <div class="login-info-text">
      <p class="help-block"></p>
    </div>
    <!-- LOGIN FORM//S -->
    <div class="well login-wrap otp-register certification-row">
      <p class="title">① {{ $t("otp.download.title") }}</p>
      <p class="title">② {{ $t("otp.QRCode.title") }}</p>
      <div class="input-area">
        <p>{{ secretKey }}</p>
        <button v-bind:class="{ 'btn-agree-view': true }" @click="copy">
          {{ $t("deposit.copy") }}
        </button>
      </div>
      <p class="title">③ {{ $t("otp.enterVerificationCode") }}</p>
      <vs-input
        type="text"
        pattern="[0-9]*"
        inputmode="decimal"
        :placeholder="$t('otp.sixDigits')"
        class="input-block input-custom"
        v-model="otpNumber"
      ></vs-input>
      <div class="button-wrap">
        <router-link to="/mypage/auth">
          <vs-button
            color="dark"
            class="btn-block custom login-gray"
            type="filled"
            @click="$router.go(-1)"
            >{{ $t("confirm.cancel") }}</vs-button
          >
        </router-link>
        <vs-button
          color="danger"
          class="btn-block custom send-email"
          vs-type="filled"
          @click="otpCompletedPopup = true"
          >{{ $t("confirm.done") }}</vs-button
        >
      </div>
    </div>
    <!-- LOGIN FORM//E -->
    <!-- <div>
      <img :src="secretKey_body.qr">
    </div>-->

    <!-- OTP 앱 설정완료//S -->
    <vs-popup :title="$t('otpComplete.title')" :active.sync="otpCompletedPopup">
      <p class="text-center">
        {{ $t("otpComplete.content[0]") }}
        <br />
        {{ $t("otpComplete.content[1]") }}
      </p>
      <div class="otp-register certification-row">
        <div class="input-area">
          <p>{{ secretKey }}</p>
          <button v-bind:class="{ 'btn-agree-view': true }" @click="copy">
            {{ $t("deposit.copy") }}
          </button>
        </div>
      </div>
      <vs-button
        color="primary"
        @click="otpCompletedPopup = false"
        class="btn-block custom"
        type="filled"
        >{{ this.$t("confirm.cancel") }}</vs-button
      >
      <vs-button
        color="primary"
        @click="confirm"
        class="btn-block custom"
        vs-type="filled"
        >{{ this.$t("confirm.ok") }}</vs-button
      >
    </vs-popup>
    <!-- OTP 인증 해지//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import Clipboard from "copy-to-clipboard";
import { mapGetters } from "vuex";
export default {
  created() {
    this.getQRCode();
  },
  data() {
    return {
      secretKey: "",
      otpNumber: "",
      secretKey_body: {},
      otpCompletedPopup: false,
    };
  },
  methods: {
    OtpCompletedPopup() {
      var text = `
          <p class='text-center'>OTP 앱 설정 완료 되었습니다.<br>추후 복구를 위해서는 복구 코드가 필요합니다.</p>
          <div class="otp-register certification-row">
            <div class="input-area">
              <p>{{secretKey}}</p>
              <button v-bind:class="{'btn-agree-view':true}" @click="copy">복사</button>
            </div>
          </div>
        `;
      this.$ev.$emit("popup", {
        title: "OTP 앱 설정완료",
        content: text,
        hasHTML: true,
        buttons: [
          {
            type: "OK",
            text: this.$t("confirm.ok"),
            onClick: () => {
              //this.$router.replace({ name: 'Main' });
              this.confirm();
            },
          },
        ],
      });
    },
    getQRCode(recoveryCode = "") {
      Api.User.getOTPQrCode(recoveryCode).then((response) => {
        response.body.qr = (response.body.qr || "").replace(/\&amp;/g, "&");
        this.secretKey_body = response.body;
        this.secretKey = response.body.recoveryCode;
      });
    },
    copy() {
      Clipboard(this.secretKey);
      this.$vs.notify({
        title: this.$t("notice.title.copied"),
        text: "복사되었습니다.",
        type: "warning",
        position: "top-left",
      });
    },
    confirm() {
      Api.User.registOTP({ secret: this.secretKey, authNumber: this.otpNumber })
        .then((response) => {
          this.$vs.notify({
            duration: 3000,
            title: "완료",
            type: "warning",
            text: "OTP 설정이 완료 되었습니다.",
            customClass: "dexko-noti",
            position: "top-left",
          });
          this.otpCompletedPopup = false;
          setTimeout(() => {
            this.$router.go(-1);
          }, 50);
        })
        .catch((e) => {
          this.failNoti(e.msg, "인증 실패");
        });
    },
    failNoti(text, title) {
      this.$vs.notify({
        title,
        text,
        position: "top-right",
        color: "danger",
      });
    },
  },
};
</script>
<style scoped></style>
